import { Login } from "@/components/login";
import { createFileRoute, redirect } from "@tanstack/react-router";

type SearchParams = {
  redirect?: string;
};

export const Route = createFileRoute("/_auth/login")({
  component: RouteComponent,
  loader: ({ context }) => {
    if (context.user) {
      throw redirect({
        to: "/gateways",
      });
    }
  },
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      redirect: search.redirect as string,
    };
  },
});

function RouteComponent() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-4xl">
        <Login redirect={Route.useSearch().redirect} />
      </div>
    </div>
  );
}
